/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEllipsis4: {
  name: 'ellipsis-4';
  data: string;
} = {
  name: 'ellipsis-4',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6-6a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM4 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" fill="currentColor"/></svg>`,
};
